import { Keys, Scene } from "excalibur";
import { hiveState, inventoryState } from "../state/stateManager";
import createKozUniversity from "../beeTypes/kozUniversity";
import createCommercial from "../beeTypes/commercial";
import createMaryEllen from "../beeTypes/maryEllen";
import createRosk from "../beeTypes/rosk";
import createFurdland from "../beeTypes/furdland";
import createKozmanian from "../beeTypes/kozmanian";
import {
  addExperience,
  createGainedItem,
  roundDown,
  sendAlert,
} from "../utils";
import { goToScene } from "../main";
import { Resources } from "../Resources";

export default class AddHive extends Scene {
  constructor() {
    super();
    console.log("inside addHive scene");
    this.container = document.getElementById("add-hive-menu");
    this.menuItems = 3;
    this.activeItem = 0;
    this.selected = null;
  }
  onActivate(pos) {
    this.inventory = inventoryState.getInventory();
    this.container.classList.add("activeAddHive");
    this.container.innerHTML = `<h1>Add Hive: Select Bees From Inventory</h1>
    <p>Enter>Continue X> BACK</p>
    <div id="beeTypeMenu"class="beeTypeMenu"><div id="addNuc" class="activeProduct"><p>Nucs: ${this.inventory.nucs.length}</p></div>
    <div id="addPackage"><p>Packages: ${this.inventory.packages.length}</p></div>
    <div id="addSplit"><p>Splits: ${this.inventory.splits.length}</p></div>
    </div>`;
    this.selectNuc = document.getElementById("addNuc");
    this.selectPackage = document.getElementById("addPackage");
    this.selectSplit = document.getElementById("addSplit");
    this.beeTypeMenu = document.getElementById("beeTypeMenu");

    this.pos = { ...pos.data };
    this.yard = this.pos.yard;
    console.log(
      "inside addHive onActivate: should add to :",
      this.pos.x,
      " y : ",
      this.pos.y
    );
    let hives = hiveState.getHives();

    console.log("addHive hives inconstructor: ", hiveState.getHives());
    this.hives = [...hives];
  }
  onDeactivate() {
    this.container.innerHTML = ``;
    this.container.style.display = "none";
    this.container.classList.remove("activeAddHive");
    this.activeItem = 0;
    this.selected = null;
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(Keys.Left)) {
      console.log("clicked left");
      if (this.activeItem === 0) {
        this.activeItem = 3;
      } else {
        this.activeItem = this.activeItem - 1;
      }
      if (this.selected === null) {
        this.showProper();
      } else {
        if (this.selected === 0) {
          this.showNucMenu();
        } else if (this.selected === 1) {
          this.showPackageMenu();
        } else if (this.selected === 2) {
          this.showSplitMenu();
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Right)) {
      if (this.activeItem === 3) {
        this.activeItem = 0;
      } else {
        this.activeItem++;
      }
      if (this.selected === null) {
        this.showProper();
      } else {
        if (this.selected === 0) {
          this.showNucMenu();
        } else if (this.selected === 1) {
          this.showPackageMenu();
        } else if (this.selected === 2) {
          this.showSplitMenu();
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.Enter)) {
      let inventory = inventoryState.getInventory();
      if (this.selected === null) {
        if (this.activeItem === 0) {
          this.selected = 0;
          this.activeItem = 0;
          this.showNucMenu();
        } else if (this.activeItem === 1) {
          this.selected = 1;
          this.activeItem = 0;
          this.showPackageMenu();
        } else if (this.activeItem === 2) {
          this.selected = 2;
          this.activeItem = 0;
          this.showSplitMenu();
        }
      } else {
        //should add
        console.log("should add hive");
        if (this.selected === 0) {
          //add active nuc
          console.log("adding nuc");
          if (this.inventory.nucs.length > 0) {
            let bees = { ...this.inventory.nucs[this.activeItem] };
            bees.type = "nuc";
            console.log("addhive before callAddhivestate: ", this.hives);
            if (inventory.boxes < 1) {
              sendAlert("Not Enough Boxes");
              return;
            }

            this.addHiveToState(bees);
          } else {
            Resources.Error.play();
            sendAlert("No Bees To Add");
          }
        } else if (this.selected === 1) {
          //add active package
          console.log("adding package");
          if (this.inventory.packages.length > 0) {
            let bees = { ...this.inventory.packages[this.activeItem] };
            bees.type = "package";
            console.log("addhive before callAddhivestate: ", this.hives);
            if (inventory.boxes < 1) {
              sendAlert("Not Enough Boxes");
              return;
            }

            this.addHiveToState(bees);
          } else {
            Resources.Error.play();
            sendAlert("No Bees To Add");
          }
        } else if (this.selected === 2) {
          //add active split

          if (inventory.boxes < 1) {
            sendAlert("Not Enough Boxes");
            return;
          }
          if (inventory.splits.length > 0) {
            let hives = hiveState.getHives();
            this.inventory.splits[this.activeItem].position = {
              x: this.pos.x * 16,
              y: this.pos.y * 16,
              yard: this.yard,
            };
            hives.push(this.inventory.splits[this.activeItem]);
            inventory.boxes = inventory.boxes - 1;
            inventory.splits.splice(this.activeItem, 1);
            console.log("split: added hive");
            goToScene("home", { x: this.pos.x * 16, y: this.pos.y * 16 });
          } else {
            Resources.Error.play();
            sendAlert("No Splits To Add");
          }
        }
      }
    }
    if (this.engine.input.keyboard.wasPressed(Keys.X)) {
      if (this.selected !== null) {
        this.selected = null;
        this.activeItem = 0;
        this.menuItems = 3;
        this.onActivate({ data: this.pos });
      } else {
        if (this.yard == "home") {
          goToScene("home", { x: this.pos.x * 16, y: this.pos.y * 16 });
        } else {
          goToScene("back40", { x: this.pos.x * 16, y: this.pos.y * 16 });
        }
      }
    }
  }
  showNucMenu() {
    this.menuItems = this.inventory.nucs.length;

    this.container.innerHTML = `
    <h1>Nucs</h1><p>Enter>Continue X> BACK</p><div id="beeTypeMenu" class="beeTypeMenu">${
      this.inventory.nucs.length > 0
        ? this.inventory.nucs.map((nuc, i) => {
            if (i === this.activeItem) {
              return `<div class="activeProduct"><p>${nuc.breed}</p></div>`;
            } else {
              if (i >= 4) {
                return;
              } else {
                return `<div><p>${nuc.breed}</p></div>`;
              }
            }
          })
        : "<p>No Nucs In Inventory. Purchase Bees Online Or In Town.</p>"
    }</div>
    
    `;
  }
  showPackageMenu() {
    this.menuItems = this.inventory.packages.length;

    this.container.innerHTML = `
    <h1>Packages</h1><p>Enter>Continue X> BACK</p><div id="beeTypeMenu" class="beeTypeMenu">${
      this.inventory.packages.length > 0
        ? this.inventory.packages.map((pac, i) => {
            if (i === this.activeItem) {
              return `<div class="activeProduct"><p>${pac.breed}</p></div>`;
            } else {
              if (i >= 4) {
                return;
              } else {
                return `<div><p>${pac.breed}</p></div>`;
              }
            }
          })
        : "<p>No Packages In Inventory. Purchase Bees Online Or In Town.</p>"
    }</div>
    
    `;
  }
  addHiveToState(bees) {
    console.log("adding hive: hives object is", this.hives);

    let position = {
      x: Math.floor(this.pos.x) * 16,
      y: Math.floor(this.pos.y) * 16,
      yard: this.yard,
    };
    console.log("addHiveToState: position is : ", position, " bees: ", bees);
    let beeFrameAmount = 6;
    let broodFrameAmount = 0;
    if (bees.type == "nuc") {
      beeFrameAmount = 5;
      broodFrameAmount = 4;
    }
    let hive;
    let now = new Date().toUTCString();
    if (bees.type == "split") {
      hive = bees.hive;
      hive.position = {
        x: position.x,
        y: position.y,
        yard: position.yard,
      };
    } else {
      switch (bees.breed) {
        case "kozUniversity":
          hive = createKozUniversity(
            {
              x: position.x,
              y: position.y,
              yard: position.yard,
            },
            beeFrameAmount,
            broodFrameAmount,
            `${bees.breed} ${bees.type}`
          );
          break;
        case "commercial":
          hive = createCommercial(
            {
              x: position.x,
              y: position.y,
              yard: position.yard,
            },
            beeFrameAmount,
            broodFrameAmount,
            `${bees.breed} ${bees.type}`
          );
          break;
        case "maryEllen":
          hive = createMaryEllen(
            {
              x: position.x,
              y: position.y,
              yard: position.yard,
            },
            beeFrameAmount,
            broodFrameAmount,
            `${bees.breed} ${bees.type}`
          );
          break;
        case "rosk":
          hive = createRosk(
            {
              x: position.x,
              y: position.y,
              yard: position.yard,
            },
            beeFrameAmount,
            broodFrameAmount,
            `${bees.breed} ${bees.type}`
          );
          break;
        case "furdland":
          hive = createFurdland(
            {
              x: position.x,
              y: position.y,
              yard: position.yard,
            },
            beeFrameAmount,
            broodFrameAmount,
            `${bees.breed} ${bees.type}`
          );
          break;
        case "kozmanian":
          hive = createKozmanian(
            {
              x: position.x,
              y: position.y,
              yard: position.yard,
            },
            beeFrameAmount,
            broodFrameAmount,
            `${bees.breed} ${bees.type}`
          );
          break;
        default:
          break;
      }
    }
    console.log("adding hive after creation of hive: ", this.hives);
    let inventory = inventoryState.getInventory();
    inventory.boxes = inventory.boxes - 1;
    let index;
    if (bees.type == "nuc") {
      index = inventory.nucs.findIndex((i) => {
        return i.breed === bees.breed;
      });
      inventory.nucs.splice(index, 1);
    } else if (bees.type == "package") {
      console.log("trying to remove package");
      index = inventory.packages.findIndex((i) => {
        console.log("got package to remove");
        return i.breed === bees.breed;
      });
      inventory.packages.splice(index, 1);
    } else if (bees.type == "split") {
      index = inventory.splits.findIndex((i) => {
        return i.birth === hive.birth;
      });
      inventory.splits.splice(index, 1);
    }

    inventoryState.setInventory(inventory);
    let newHives = [...this.hives];

    newHives.push(hive);
    hiveState.setHives(newHives);
    console.log("addhive after sethives: ", this.hives);
    addExperience(2);
    createGainedItem("Experience +2!");
    createGainedItem("Added Hive!");
    if (this.yard == "home") {
      goToScene("home", { x: position.x, y: position.y });
    } else {
      goToScene("back40", { x: position.x, y: position.y });
    }
  }
  showSplitMenu() {
    this.menuItems = this.inventory.splits.length;

    this.container.innerHTML = `
    <h1>Splits</h1><div id="beeTypeMenu" class="beeTypeMenu">${
      this.inventory.splits.length > 0
        ? this.inventory.splits.map((split, i) => {
            if (i === this.activeItem) {
              return `<div class="activeProduct"><p>${split.queenStats.breed}</p></div>`;
            } else {
              if (i >= 4) {
                return;
              } else {
                return `<div><p>${split.queenStats.breed}</p></div>`;
              }
            }
          })
        : "<p>No Splits In Inventory. To Create Splits, Split Your Bees In The Hive Menu.</p>"
    }</div>
    
    `;
  }
  showProper() {
    console.log("inside showProper, activeItem is :", this.activeItem);
    if (this.selected === null) {
      if (this.activeItem === 0) {
        this.selectNuc.classList.add("activeProduct");
        this.selectPackage.classList.remove("activeProduct");
        this.selectSplit.classList.remove("activeProduct");
      } else if (this.activeItem === 1) {
        this.selectNuc.classList.remove("activeProduct");
        this.selectPackage.classList.add("activeProduct");
        this.selectSplit.classList.remove("activeProduct");
      } else if (this.activeItem === 2) {
        this.selectNuc.classList.remove("activeProduct");
        this.selectPackage.classList.remove("activeProduct");
        this.selectSplit.classList.add("activeProduct");
      }
    }
  }
}
